export default __webpack_public_path__ + "static/media/sdmovies_logo_shadow.16c45526.png";